import {Image} from "@mui/icons-material";
import TestimonialCategoriesList from "./TestimonialCategoriesList";
import TestimonialCategoriesEdit from "./TestimonialCategoriesEdit";
import TestimonialCategoriesCreate from "./TestimonialCategoriesCreate";

export default {
    list: TestimonialCategoriesList,
    edit: TestimonialCategoriesEdit,
    create: TestimonialCategoriesCreate,
    icon: Image,
};
